import styled from 'styled-components';
import { FLUENT_UI_EMOJIS } from '../../../../../../../assets';

export const WidgetIcon = styled(FLUENT_UI_EMOJIS.ROCKET)`
  width: 32px;
  height: 32px;
`;
